import React from 'react';
import PropTypes from 'prop-types';

import styles from './CampSection.module.scss';

function CampSection({
  title, children, classNames, mobileNoLayout,
}) {
  return (
    <section className={`${styles.section} ${classNames || ''} ${mobileNoLayout ? styles.mobile_nolayout : ''}`}>
      {title ? (
        <h2 className={`${styles.title} fs-14 uppercase ${mobileNoLayout ? styles.mobile_nolayout_title : ''}`}>
          {title}
        </h2>
      ) : null}
      <div>{children}</div>
    </section>
  );
}

CampSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  classNames: PropTypes.string,
  mobileNoLayout: PropTypes.bool,
};

CampSection.defaultProps = {
  title: null,
  classNames: null,
  mobileNoLayout: false,
};

export default CampSection;
